import { Select } from "@shopify/polaris";
import {
  TAGS_SELECTION_LOGIC_EXCLUDE,
  TAGS_SELECTION_LOGIC_INCLUDE
} from "../../../../../../../../../../../../constants/tagsSelectionLogic.js";

const options = [
  { label: "Exclude the selected tags", value: TAGS_SELECTION_LOGIC_EXCLUDE },
  { label: "Include the selected tags", value: TAGS_SELECTION_LOGIC_INCLUDE }
];

const SelectionLogicField = ({ input }) => {
  return (
    <Select
      label="Selection Logic"
      options={options}
      onChange={input.onChange}
      value={input.value}
    />
  );
};

export default SelectionLogicField;